import React, { lazy } from 'react';
export function ResultPersonality() {
  return <section className="bg-warm-mid py-16 md:py-20 px-4" data-id="element-218">
      <div className="max-w-3xl mx-auto text-center" data-id="element-219">
        <p className="font-sans font-medium text-soft-gold uppercase tracking-wider text-xs md:text-sm mb-3" data-id="element-220">
          Capture the little things that feel like your dog
        </p>

        <div className="mb-8 rounded-2xl overflow-hidden shadow-xl max-w-2xl mx-auto" data-id="element-221">
          <img src="https://images.unsplash.com/photo-1518717758536-85ae29035b6d?w=700&h=544&fit=crop&crop=faces&q=80" alt="Highly expressive dog in a candid moment showing real personality and emotion with warm cinematic lighting" className="w-full h-auto object-cover" loading="lazy" decoding="async" width={700} height={544} data-id="element-222" />
        </div>

        <p className="font-sans text-lg md:text-xl text-gray-800 max-w-2xl mx-auto leading-relaxed" data-id="element-223">
          Because the best dog photos are not just sharp — they feel{' '}
          <span className="font-semibold text-warm-hero" data-id="element-224">
            personal, emotional, and real.
          </span>
        </p>
      </div>
    </section>;
}